module.exports = __webpack_public_path__ + "static/portfolio_croulette-4980ba9f646d7d7adf6b549792feb1de.png";